import clsx from 'clsx';
import React from 'react';
import childrenArrayWrapper from '../../../helpers/childrenArrayWrapper';
import { Align } from '../../../types';
import type { MagazineGridProps } from './interfaces';
import styles from './MagazineGrid.module.scss';

const MagazineGrid = ({
  align = Align.Center,
  children,
}: MagazineGridProps) => {
  const baseClassNames = clsx(styles.base, styles[align]);

  if (typeof window !== 'undefined' && window.USE_MAGNOLIA_RENDERER) {
    return (
      <div className={styles.wrapper}>
        <div className={baseClassNames}>
          {childrenArrayWrapper(children, React.Fragment, true, true)}
        </div>
      </div>
    );
  }

  return <div className={baseClassNames}>{children}</div>;
};

export default MagazineGrid;
